<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Create Quote</h1>

    <div class="bg-white rounded-md shadow p-6">
      <form @submit.prevent="submit">
        <div class="mb-6">
          <text-input v-model="form.game" class="pr-6 pb-4 w-full" label="Game (optional)" />
          <text-input v-model="form.contributor" class="pr-6 pb-4 w-full" label="Contributor (optional)" />

          <label class="block text-gray-700">Date Added (optional)</label>
          <input v-model="form.added_at" type="date" class="form-input mt-1 block w-full mb-4" />

          <label class="block text-gray-700">Quote</label>
          <textarea v-model="form.quote_text" rows="6" class="form-textarea mt-1 block w-full"></textarea>
          <div v-if="form.errors.quote_text" class="text-red-500 mt-2">{{ form.errors.quote_text }}</div>
        </div>

        <div class="flex items-center">
          <button type="submit" class="btn-indigo mr-4">Save</button>
          <inertia-link :href="route('quotes')" class="text-sm text-gray-600">Cancel</inertia-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'

export default {
  components: { TextInput },
  layout: Layout,
  metaInfo: { title: 'Create Quote' },
  data() {
    return {
      form: {
        quote_text: '',
        game: '',
        contributor: '',
        added_at: '',
        errors: {},
      },
    }
  },
  methods: {
    async submit() {
      try {
        await this.$inertia.post(this.route('quotes.store'), {
          quote_text: this.form.quote_text,
          game: this.form.game,
          contributor: this.form.contributor,
          added_at: this.form.added_at,
        })
      } catch (e) {
        // handled via inertia
      }
    },
  },
}
</script>
